import React, { Component } from 'react';
import identify from "~/identify";
import {ActionMenu} from "~/ui/ActionMenu/ActionMenu";
import { Button, Divider, HStack, SaveButton, Tooltip, ScrollView } from "~/native-ui"

export default class ItemActions extends Component {
	static propTypes = {
	
	};

    renderSaveButton() {
        let { isDirty, itemId, trans, subviewCount } = this.props;

        let disableSave = (!isDirty && itemId !== identify.NEW_ITEM),
            onlyContinue = subviewCount &&  itemId === identify.NEW_ITEM,
            labelKey = onlyContinue ? 'continue' : 'save',
            icon;

        if(onlyContinue) {
            icon = "forward";
        }

        return (
            <SaveButton
                key="save"
                disabled={disableSave}
                onPress={this.props.saveItem}
                label={trans(labelKey)}
                icon={icon}
            />
        );
    }

    renderEditButton = () => {
        let { trans, itemId, actionPermissions } = this.props;

        let canEdit = itemId === identify.NEW_ITEM && actionPermissions.create || itemId !== identify.NEW_ITEM && actionPermissions.update;

        return (
            <Tooltip disabled={!canEdit} rightMargin key="edit" tooltip={trans('edit')}>
                <Button
                    primary
                    icon="create"
                    iconSize="sm"
                    onPress={this.props.editEntry}
                    disabled={!canEdit}
                    children={trans('edit')}
                />
            </Tooltip>
        );
    };

    renderMainActionButtons() {
        let { isDirty, view } = this.props;

        let buttons = [];

        if(view === identify.VIEW_VIEW) {
            buttons.push(this.renderEditButton());
        }

        if(view === identify.VIEW_EDIT) {
            buttons.push(this.renderSaveButton());
        }

        if (buttons.length && this.props.actions.length && this.props.itemId !== identify.NEW_ITEM) {
            buttons.unshift(<Divider key={"divider"} orientation="vertical" bg="coolGray.300" h="5" mx="2" />);
        }

        return buttons;
    }

    contentContainerStyle = {alignItems: "center"}
	render() {
        let { isDirty } = this.props;

        return (
            <HStack space={2} pr={4}>
                <ScrollView horizontal ml="auto" contentContainerStyle={this.contentContainerStyle}>
                    {this.props.itemId !== identify.NEW_ITEM ?
                        <ActionMenu noDivider {...this.props} disabled={isDirty} /> :
                        null
                    }

                    {this.renderMainActionButtons()}
                </ScrollView>
            </HStack>
        );
	}
}